import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EmailIcon } from '../../../assets/icons/svg/shared/ic-shared-email-support.svg';
import { ReactComponent as CallIcon } from '../../../assets/icons/svg/shared/ic-shared-call.svg';
import { ReactComponent as ChatIcon } from '../../../assets/icons/svg/shared/ic-shared-sms.svg';
import { ReactComponent as HelpIcon } from '../../../assets/icons/svg/shared/ic-shared-help.svg';

export enum SupportItemType {
  EMAIL,
  CALL,
  CHAT,
  HELP_CANTER,
}

interface AccountSettingsSupportItemProps {
  id: string;
  title: string;
  value: string;
  type: SupportItemType;
  icon: ReactNode;
  onClick: (type: SupportItemType) => void;
}

export const AccountSettingsSupportItem = ({
  id,
  title,
  value,
  icon,
  onClick,
  type,
}: AccountSettingsSupportItemProps) => (
  <button
    id={id}
    type='button'
    onClick={(e) => {
      e.stopPropagation();
      onClick(type);
    }}
    className='grow'
  >
    <div className='flex flex-row items-center gap-[8px] border-[1px] border-bw04 rounded-xl shadow-sm px-[16px] min-w-[200px]  py-[8px] max-h-[56px] hover:bg-bw00'>
      {icon}
      <div className='flex flex-col'>
        <p className='text-bw08 text-[14px] font-metricRMedium  text-left'>
          {title}
        </p>
        <p className='text-bw07 text-[12px] font-metricR text-left'>{value}</p>
      </div>
    </div>
  </button>
);

interface AccountSettingsSupportProps {
  onItemClick: (type: SupportItemType) => void;
  supportPhone: string;
  supportEmail: string;
}

// This id is used to support trigger of the chatbot by code
export const SUPPORT_ITEM_CHAT = 'support-chat';
export const AccountSettingsSupport = ({
  onItemClick,
  supportPhone,
  supportEmail,
}: AccountSettingsSupportProps) => {
  const iconStyle = 'text-bw08';
  const { t } = useTranslation();

  return (
    <div className='flex flex-row gap-[12px]   pt-[24px] my-[24px]  border-t-[1px] border-t-bw03 w-full'>
      <AccountSettingsSupportItem
        id='support-email'
        title={t('ACCOUNT_SETTINGS.SUPPORT.EMAIL.TITLE')}
        value={supportEmail}
        icon={<EmailIcon className={iconStyle} />}
        onClick={onItemClick}
        type={SupportItemType.EMAIL}
      />
      <AccountSettingsSupportItem
        id='support-call-us'
        title={`${t('ACCOUNT_SETTINGS.SUPPORT.CALL.TITLE', { phoneNumber: supportPhone })}`}
        value={t('ACCOUNT_SETTINGS.SUPPORT.CALL.VALUE')}
        icon={<CallIcon className={iconStyle} />}
        onClick={onItemClick}
        type={SupportItemType.CALL}
      />
      <AccountSettingsSupportItem
        id={SUPPORT_ITEM_CHAT}
        title={t('ACCOUNT_SETTINGS.SUPPORT.CHAT.TITLE')}
        value={t('ACCOUNT_SETTINGS.SUPPORT.CHAT.VALUE')}
        icon={<ChatIcon className={iconStyle} />}
        onClick={onItemClick}
        type={SupportItemType.CHAT}
      />
      <AccountSettingsSupportItem
        id='support-help-center'
        title={t('ACCOUNT_SETTINGS.SUPPORT.HELP_CENTER.TITLE')}
        value={t('ACCOUNT_SETTINGS.SUPPORT.HELP_CENTER.VALUE')}
        icon={<HelpIcon className={iconStyle} />}
        onClick={onItemClick}
        type={SupportItemType.HELP_CANTER}
      />
    </div>
  );
};
